import React, { useEffect, useState, useTransition, useContext } from "react";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import MainHeader from "./components/MainHeader";
import Sidebar from "./components/Sidebar";
import ServicesComponent from "./components/ServicesComponent.js";
import FilterComponent from "./components/FilterComponent.js";
import { SlMagnifier } from "react-icons/sl";
import { FaCircle } from "react-icons/fa";
import WebSocketContext from "./context/WebSocketContext.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Dashboard = () => {
  const { instance, accounts } = useMsal();
  const { socketData } = useContext(WebSocketContext);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [facets, setFacets] = useState([]);
  const [isPending, startTransition] = useTransition();
  const [nextToken, setNextToken] = useState(null);
  const [tokenHistory, setTokenHistory] = useState([]); // To track the history of tokens
  const [currentTokenIndex, setCurrentTokenIndex] = useState(-1); // Track current page index
  const [appliedFilters, setAppliedFilters] = useState({});
  const [selectedServices, setSelectedServices] = useState({});
  const [perPage, setPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // const { provider } = useCloudProvider();
  const provider = localStorage.getItem("provider");
  console.log("provider", provider);

  const handleSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen);
  };
  console.log(JSON.stringify(socketData), "socketData");

  const getToken = async () => {
    try {
      const response = await instance.acquireTokenSilent({
        scopes: ["User.Read"],
        account: accounts[0],
      });
      return response.accessToken;
    } catch (error) {
      console.error("Token acquisition failed:", error);
      return null;
    }
  };

  // Fetch stats API
  const fetchStatsData = async () => {
    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/cloud/${provider.toLowerCase()}/resources-stats`
      );
      console.log(response.data, "API Response");
      setServiceData(response.data.data); // Update with actual data
    } catch (err) {
      console.error(err.message || "Something went wrong");
    }
  };

  // Call stats API initially and whenever socketUpdate changes
  useEffect(() => {
    // Call immediately on mount
    fetchStatsData();
    // eslint-disable-next-line
  }, [socketData]);

  // Function to update filtered data based on the socket message
  const updateGroupData = (prevGroup, updatedData) => {
    return prevGroup.map((item) => {
      if (item.id?.toLowerCase() === updatedData?.topic?.toLowerCase()) {
        console.log(`Updating status for item with ID: ${item.id}`);
        return {
          ...item,
          state:
            updatedData?.data?.appEventTypeDetail?.action?.toLowerCase() ===
            "stopped"
              ? "Stopped"
              : "Running",
          eventTime: updatedData?.eventTime || item.createdTime,
        };
      }

      if (
        updatedData?.socketData?.appEventTypeDetail?.customData &&
        (item.id?.toLowerCase() ===
          updatedData.socketData?.appEventTypeDetail.customData.topic1?.toLowerCase() ||
          item.id?.toLowerCase() ===
            updatedData.socketData?.appEventTypeDetail.customData.topic2?.toLowerCase())
      ) {
        const isTopic1 =
          item.id?.toLowerCase() ===
          updatedData.socketData?.appEventTypeDetail.customData.topic1?.toLowerCase();

        return {
          ...item,
          state: isTopic1
            ? updatedData.socketData?.appEventTypeDetail.customData.topic1Status
            : updatedData.socketData?.appEventTypeDetail.customData
                .topic2Status,
          eventTime:
            updatedData?.socketData?.eventTime ||
            item.eventTime ||
            item.createdTime,
        };
      }

      return item;
    });
  };

  useEffect(() => {
    if (socketData) {
      // Update the filtered data when new socket data is received
      setFilteredData((prevGroup) => updateGroupData(prevGroup, socketData));
    }
  }, [socketData]); // Re-run when new socketData is received

  const fetchData = async (
    isToken = null,
    direction = "next",
    activeFilters = null,
    activeSelect = null,
    top = perPage,
    searchFilter = null
  ) => {
    const token = await getToken();
    console.log(token, "GetToken");

    // if (!token) return;
    setIsLoading(true);

    try {
      // Construct the base URL
      let url = `${
        process.env.REACT_APP_API_BASE_URL
      }/cloud/${provider.toLowerCase()}/resources`;

      // Add pagination size (top)
      if (top) {
        url += url.includes("?") ? `&top=${top}` : `?top=${top}`;
      }

      // Add filters if they exist
      if (activeFilters && Object.keys(activeFilters).length > 0) {
        const encodedFilters = encodeURIComponent(
          JSON.stringify(activeFilters)
        );
        url += `&filters=${encodedFilters}`;
      }

      // Append activeSelect (checkbox query parameters)
      if (activeSelect) {
        url += `&${activeSelect}`;
        console.log(activeSelect, "activeSelect");
      }

      // Add search filter
      if (searchFilter) {
        url += `&searchFilter=${searchFilter}`;
      }

      // Add skipToken if it exists
      if (isToken) {
        // const skipTokenParam = activeFilters && Object.keys(activeFilters).length > 0
        //   ? `&skipToken=${isToken}`
        //   : `&skipToken=${isToken}`;
        url += `&skipToken=${isToken}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const updatedData = response.data.data.data.map((item) => ({
        ...item,
        state:
          item.state === "PowerState/deallocated"
            ? "Stopped"
            : item.state === "PowerState/running"
            ? "Running"
            : item.state,
      }));

      setFilteredData(updatedData);

      // Update facets only if they exist in the response
      if (response?.data?.data?.facets) {
        setFacets(response?.data?.data?.facets);
      }

      // const totalRecords = response.data.data.totalRecords;
      // const nextToken = totalRecords !== 5  ? response.data.data.$skipToken : null;

      const nextToken = response.data.data.$skipToken;

      if (direction === "next") {
        setTokenHistory((prevHistory) => [...prevHistory, isToken || null]);
        setCurrentTokenIndex((prevIndex) => prevIndex + 1);
        setNextToken(nextToken);
      } else if (direction === "previous" && currentTokenIndex > 0) {
        setCurrentTokenIndex((prevIndex) => prevIndex - 1);
        setNextToken(nextToken); // Update nextToken for further navigation
      }
    } catch (err) {
      console.error(err.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const labelGroups = {
    serverlessWorkflowChecked: ["Logic App", "Workflow"],
    appHostingChecked: ["App Service", "Elastic Beanstalk"],
    serverlessComputingChecked: ["Function App", "Lambda", "Cloud Function"],
    computeServiceChecked: ["Virtual Machine", "EC2", "Compute Engine"],
    dbServerChecked: ["SQL Server", "RDS", "SQL"],
    kubernetesChecked: ["Kubernetes", "EKS", "GKE"],
    postgreSqlFlexibleServerChecked: ["PostgreSQL Flexible Serve"]
  };

  // Create flat labelToQueryKeyMap from grouped labels
  const labelToQueryKeyMap = Object.fromEntries(
    Object.entries(labelGroups).flatMap(([queryKey, labels]) =>
      labels.map((label) => [label, queryKey])
    )
  );

  // ✅ Safer helper function
  const generateCheckboxQuery = (selectedServices) => {
    return Object.keys(selectedServices)
      .filter((label) => selectedServices[label] && labelToQueryKeyMap[label])
      .map((label) => `${labelToQueryKeyMap[label]}=true`)
      .join("&");
  };

  // Handle checkbox changes
  const handleCheckboxChange = (label, isChecked) => {
    console.log(label, "label");

    setSearchTerm("");
    setSelectedServices((prev) => {
      const updated = { ...prev, [label]: isChecked };
      const selectedCheck = generateCheckboxQuery(updated);
      fetchData(null, "next", appliedFilters, selectedCheck);
      return updated;
    });
  };
  // Handle filter changes
  const handleFilterChange = (filterParams) => {
    console.log(filterParams, "filterParams");

    startTransition(() => {
      setAppliedFilters(filterParams);
      const selectedCheck = generateCheckboxQuery(selectedServices);
      fetchData(null, "next", filterParams, selectedCheck);
      setCurrentTokenIndex(0); // Reset pagination
    });
  };

  // Handle per page changes
  const handlePerPageChange = (e) => {
    const selectedValue = e.target.value;
    setPerPage(selectedValue);
    const selectedCheck = generateCheckboxQuery(selectedServices);
    fetchData(null, "next", appliedFilters, selectedCheck, selectedValue);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setTokenHistory([]);
    setCurrentTokenIndex(0);
    setNextToken(null);
    const selectedCheck = generateCheckboxQuery(selectedServices);
    // Trigger API call with the search term
    fetchData(null, "next", appliedFilters, selectedCheck, perPage, value);
  };

  const handleNext = () => {
    if (nextToken) {
      const selectedCheck = generateCheckboxQuery(selectedServices);
      fetchData(nextToken, "next", appliedFilters, selectedCheck);
    }
  };

  const handlePrevious = () => {
    if (currentTokenIndex > 0) {
      const previousToken = tokenHistory[currentTokenIndex - 1];
      const selectedCheck = generateCheckboxQuery(selectedServices);
      fetchData(previousToken, "previous", appliedFilters, selectedCheck);
    }
  };

  // Handle checkbox change
  const handleCheckboxChange1 = (data) => {
    setSelectedItems((prevSelected) =>
      prevSelected.some((item) => item.id === data.id)
        ? prevSelected.filter((item) => item.id !== data.id)
        : [...prevSelected, data]
    );
  };

  // Handle submit
  const handleSubmit = async () => {
    if (selectedItems.length === 0) {
      alert("Please select at least one item!");
      return;
    }
    try {
      const response = await axios.post(
        "https://devwebsocket.drtestdash.com/runbook/generate-excel",
        {
          selectedResources: selectedItems,
        }
      );
      if (response.status === 200) {
        setSelectedItems([]);
        toast.success("Run book generated successfully!");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while generating the Excel file.");
    }
  };

  return (
    <>
      <Sidebar onToggle={handleSidebarToggle} />
      <div
        className={`content p-5 ${
          isSidebarOpen ? "content-expanded" : "content-collapsed"
        }`}
      >
        <MainHeader></MainHeader>

        <div className="ps-4 mt-4">
          <div className="main-panel">
            <div>
              <div className="w-100">
                <ServicesComponent
                  data={serviceData}
                  selectedServices={selectedServices}
                  onCheckboxChange={handleCheckboxChange}
                />
                <div
                  className="card mt-3"
                  style={{ height: "370px", overflow: "hidden" }}
                >
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div>
                        <h5 className="card-title me-3">
                          Current System State
                        </h5>
                      </div>
                      <div>
                        <select
                          className="form-select w-auto"
                          value={perPage}
                          onChange={handlePerPageChange}
                        >
                          <option value={5}>5 per page</option>
                          <option value={10}>10 per page</option>
                          <option value={20}>20 per page</option>
                        </select>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={handleSubmit}
                        disabled={selectedItems.length === 0}
                      >
                        Generate Runbook
                      </button>
                      <div className="input-group w-50">
                        <input
                          type="text"
                          placeholder="Search ..."
                          className="form-control"
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text h-100">
                            <SlMagnifier />
                          </span>
                        </div>
                      </div>
                      <FilterComponent
                        facets={facets}
                        onFilterChange={handleFilterChange}
                      />
                    </div>
                  </div>

                  <div className="card-body dashboard p-0">
                    {isLoading || isPending ? (
                      <div className="d-flex justify-content-center my-4">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="dashboard-table">
                        <table className="table table-responsive table-alter">
                          <thead className="tablebg">
                            <tr>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                <input
                                  type="checkbox"
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedItems(filteredData);
                                    } else {
                                      setSelectedItems([]);
                                    }
                                  }}
                                />
                              </th>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom "
                              >
                                Resource Name
                              </th>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Resource type
                              </th>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Resource Tag
                              </th>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Project Name
                              </th>
                              <th
                                scope="col"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Location
                              </th>
                              <th
                                scope="col-2"
                                className="text-uppercase tablebgtext border-top border-bottom"
                              >
                                Status
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredData.length > 0 ? (
                              filteredData.map((data) => {
                                const state = data?.state?.toLowerCase();
                                const running = state === "running";
                                const runnable = state === "runnable";
                                const stopped = state === "stopped";
                                const ready = state === "ready";
                                const deallocate = state === "deallocated";
                                const disabled = state === "disabled";

                                const badgeClass = (running || runnable)
                                  ? "text-success"
                                  : stopped
                                  ? "text-danger"
                                  : ready
                                  ? "text-warning"
                                  : deallocate
                                  ? "text-danger"
                                  : disabled
                                  ? "text-secondary"
                                  : "text-primary";
                                return (
                                  <tr id={data?.id} key={data?.id}>
                                    <td className="border-0">
                                      <input
                                        type="checkbox"
                                        checked={selectedItems.some(
                                          (item) => item.id === data.id
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange1(data)
                                        }
                                      />
                                    </td>
                                    <td className="border-0 fw-bold ps-2">
                                      {data?.name}
                                    </td>
                                    <td className="border-0">{data?.type}</td>

                                    <td className="border-0">
                                      {data?.resourceTags?.Name || data?.resourceTags?.name || "-"}
                                    </td>
                                    <td className="border-0">
                                      {data?.projectName || "-"}
                                    </td>
                                    <td className="border-0">
                                      {data?.location}
                                    </td>
                                    <td className="border-0">
                                      <div>
                                        {data?.state ? (
                                          <>
                                            <FaCircle
                                              className={`font-circle ${badgeClass}`}
                                            ></FaCircle>{" "}
                                            {data?.state
                                              ?.charAt(0)
                                              .toUpperCase() +
                                              data?.state
                                                ?.slice(1)
                                                .toLowerCase()}
                                          </>
                                        ) : (
                                          <p className="text-center">-</p>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  No Data Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
                <div className="pagination-controls d-flex justify-content-end">
                  <div>
                    <button
                      className="button-17 me-2"
                      onClick={handlePrevious}
                      disabled={currentTokenIndex === 0}
                    >
                      Previous
                    </button>
                    <button
                      className="button-17"
                      onClick={handleNext}
                      disabled={!nextToken}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
